import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Sparkles, Lock } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface RegisterToViewModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  contentName?: string;
  accessLevel?: string | null;
}

export const RegisterToViewModal = ({ open, onOpenChange, contentName, accessLevel }: RegisterToViewModalProps) => {
  const navigate = useNavigate();
  const isSubscription = accessLevel === "subscription";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
            <Lock className="h-7 w-7 text-primary" />
          </div>
          <DialogTitle className="text-center text-xl">
            {isSubscription
              ? "Necesitas una suscripción para ver este contenido"
              : "Regístrate para ver este contenido"}
          </DialogTitle>
          <DialogDescription className="text-center">
            {isSubscription
              ? "Este recurso es exclusivo para miembros con plan activo. Crea tu cuenta y activa tu plan para desbloquearlo."
              : "Crea tu cuenta gratis y accede a videos, lecturas, clases con LIA y muchos más recursos para liderar la IA."}
          </DialogDescription>
        </DialogHeader>

        {contentName && (
          <div className="rounded-lg border border-border bg-muted/40 p-3 text-sm">
            <div className="flex items-start gap-2">
              <Sparkles className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
              <div>
                <p className="text-xs text-muted-foreground">Quieres ver:</p>
                <p className="font-medium line-clamp-2">{contentName}</p>
              </div>
            </div>
          </div>
        )}

        <div className="flex flex-col gap-2 pt-2">
          <Button
            className="w-full"
            onClick={() => {
              onOpenChange(false);
              navigate("/auth?mode=signup");
            }}
          >
            Crear cuenta gratis
          </Button>
          {isSubscription ? (
            <Button
              variant="outline"
              className="w-full"
              onClick={() => {
                onOpenChange(false);
                navigate("/planes");
              }}
            >
              Ver planes
            </Button>
          ) : (
            <Button
              variant="outline"
              className="w-full"
              onClick={() => {
                onOpenChange(false);
                navigate("/auth?mode=login");
              }}
            >
              Ya tengo cuenta — Iniciar sesión
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};


export default RegisterToViewModal;
